// libs.
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// slices.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { setPricingTasks } from '@domains/documents-review/store/slices/document-review-slice';
import { useGetListTasksQuery } from '@domains/documents-review/store/api-slices/list-tasks.endpoints';

interface UseFetchingDocumentsTasksProps {
  status: string;
  business_type?: string;
}

export const useFetchingDocumentsTasks = ({
  status,
  business_type,
}: UseFetchingDocumentsTasksProps) => {
  const dispatch = useDispatch();
  const country = useSelector(getCountry);

  const { data, isFetching, refetch } = useGetListTasksQuery(
    {
      country,
      status,
      business_type,
    },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (!isFetching && data) {
      dispatch(setPricingTasks(data));
    }
  }, [data, isFetching, dispatch]);

  return {
    data: data ?? [],
    isFetching,
    refetch,
  };
};
